import React, {useEffect, useState} from "react";
import {
    Autocomplete,

    Box, Button,
    Container, Drawer, FormControl,
    Grid, InputLabel,
    Paper, Select, Stack, Tab, Tabs,
} from "@mui/material";
import MainLayout from "../MainLoyout/MainLayout";

import Title from "../Title";
import Api from "../../Services/Api";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import {useSelector} from "react-redux";
import Success from "../Snackbar/Success";
import TextField from "@mui/material/TextField";
import {check, updateDemandFeeds, updateSupplyFeeds} from "../../features/users/Users";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import SimpleTabPanel from "../SimpleTabPanel";


const DemandStats = () => {

    const [demandStats, setDemandStats] = React.useState([]);
    const [demandFeedId, setDemandFeedId] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [form, setForm] = React.useState(false);

    const [apiMessage, setApiMessage] = React.useState(null);
    const [demandFeeds, setDemandFeeds] = React.useState([]);
    const [demandPartners, setDemandPartners] = React.useState([]);

    const [supplyFeeds, setSupplyFeeds] = React.useState([]);
    const [tab, setTab] = React.useState("automatic");


    const [loading, setLoading] = React.useState(true);
    const [pageSize, setPageSize] = React.useState(100);

    useEffect(() => {

        loadStats()

    }, []);

    const loadStats = async (data) => {
        setLoading(true)
        await Api.demandStats(data).then(r => {
            setDemandStats(r)
        })
        await Api.demand(data).then(r => {
            setDemandFeeds(r)
        })

        await Api.demandPartners().then(r => {
            setDemandPartners(Object.values(r))
        })
        setLoading(false)
    }

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const timeSince = (date) => {

        var seconds = Math.floor((new Date() - date) / 1000);

        var interval = seconds / 31536000;

        if (interval > 1) {
            return Math.floor(interval) + " years";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + " months";
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return Math.floor(interval) + " days";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes";
        }
        return Math.floor(seconds) + " seconds";

    }

    const formatNumber = (value) => {
        if (isNaN(value) || value === null) return 0
        const valueFormatted = parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }

    const columns = [
        {
            field: "id",
            headerName: "Id",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 100

        },
        {
            field: "date",
            headerName: "Date",
            type: 'string',
            editable: true,
            flex: 0.2,
            minWidth: 100

        },
        {
            field: "created_at",
            headerName: "Created",
            type: 'date',
            editable: false,
            flex: 0.2,
            hide: true,
            minWidth: 100,
            valueFormatter: (params) => timeSince(new Date(params.value)) + " ago",
        },
        {
            field: "updated_at",
            headerName: "Updated",
            type: 'date',
            editable: false,
            flex: 0.1,
            minWidth: 100,
            valueFormatter: (params) => timeSince(new Date(params.value)) + " ago",
        },
        {
            field: "demand",
            headerName: "Demand",
            type: 'string',
            editable: false,
            flex: 0.3,
            minWidth: 150,
            valueGetter: (params) => params.row?.demand_user?.name

        },
        {
            field: "supply",
            headerName: "Supply",
            type: 'string',
            editable: false,
            flex: 0.3,
            minWidth: 150,
            valueGetter: (params) => params.row?.supply_user?.name

        },
        {
            field: "demand_feed_id",
            headerName: "Demand Id",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "supply_feed_id",
            headerName: "Supply Id",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "source",
            headerName: "Source",
            type: 'string',
            editable: false,
            hide: true,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "keyword",
            headerName: "Keyword",
            type: 'string',
            editable: false,
            hide: true,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "supply_margin",
            headerName: "S. Margin",
            type: 'number',
            editable: true,
            step: "0.1",
            hide: true,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "demand_margin",
            headerName: "D. Margin",
            type: 'number',
            editable: true,
            step: "0.1",
            hide: true,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "revenue",
            headerName: "Revenue",
            type: 'number',
            editable: true,
            flex: 0.2,
            minWidth: 100,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value)
                return "$" + valueFormatted;
            }

        },
        {
            field: "searches",
            headerName: "Searches",
            type: 'number',
            editable: true,
            flex: 0.2,
            minWidth: 100

        },
        {
            field: "clicks",
            headerName: "Clicks",
            type: 'number',
            editable: true,
            flex: 0.2,
            minWidth: 100

        },
    ]

    const handleChange = (event) => {


        if (event.target.name == "demand_feed_id") {
            loadStats({"demand_feed_id": event.target.value})
            setDemandFeedId(event.target.value)
        }

    };

    const onCellEditCommit = (params, event) => {
        Api.updateDemandStats(params).then(r => setApiMessage(r))
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open)
        setSupplyFeeds([])

    };


    const handleSubmit = async (event) => {
        setOpen(false)

        event.preventDefault();
        if (form.file !== undefined) {
            Api.createDemandStatsCSV(form).then(r => {
                setApiMessage(r)

                loadStats()

            })
        } else {
            Api.createDemandStats(form).then(r => {
                setApiMessage(r)

                loadStats()

            })
        }

        setForm([]);


    }

    const handleChangeForm = (event) => {


        if (event.target.name == "demand_feed_id") {
            const demandFeed = demandFeeds.filter((item) => {
                return item.id == event.target.value
            })
            setSupplyFeeds(demandFeed[0].supply_feeds)
        }


        if (event.target.name == "file") {

            setForm(prevState =>
                ({
                    ...prevState,
                    [event.target.name]: event.target.files[0]
                })
            )
        } else {


            setForm(prevState =>
                ({
                    ...prevState,
                    [event.target.name]: event.target.value
                })
            )
        }
    };

    const handleChangeDate = (event) => {

        let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        let date = (new Date(event - tzoffset)).toISOString().slice(0, -1);


        setForm(prevState =>
            ({
                ...prevState,
                "date": date
            })
        )
    };

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };


    return (
        <MainLayout>
            <Success successMessage={apiMessage} setSuccessMessage={setApiMessage}>
                {apiMessage?.message}
            </Success>


            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2}}>
                    <Title>Demand Stats</Title>
                    <Box sx={{display: 'flex'}}>
                        <FormControl sx={{minWidth: 250, flexGrow: 1, mr: 3}} size={"small"}>
                            <InputLabel id="demand-feed-id">Demand Feed</InputLabel>
                            <Select
                                name={"demand_feed_id"}
                                labelId="demand-feed-id"
                                id="demo-simple-select"
                                value={demandFeedId ?? "All"}
                                label="Demand Feed Id"
                                onChange={handleChange}
                            >
                                <MenuItem value={null}>ALL</MenuItem>
                                {demandFeeds.map((item) => <MenuItem
                                    value={item.id}>{item.id + " - " + item.needle + " (" + item.user?.name + ")"}</MenuItem>)}


                            </Select>
                        </FormControl>

                        <Button variant="contained" onClick={toggleDrawer(true)}>+ Add new stats</Button>
                    </Box>
                    <DataGrid
                        rows={!loading ? demandStats : []}
                        columns={columns}
                        pageSize={pageSize}
                        onCellEditCommit={onCellEditCommit}

                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        autoHeight={true}
                        disableSelectionOnClick
                        rowsPerPageOptionsSkeleton
                        components={{
                            LoadingOverlay: LoadingSkeleton,
                            Toolbar: GridToolbar,

                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}


                        sx={{
                            mt: 2,
                            mb: 2,
                            minHeight: 600,
                        }}
                        density={"compact"}

                        loading={loading}
                    />

                    <Drawer
                        anchor={"right"}
                        open={open}
                        onClose={toggleDrawer(false)}
                    >

                        <Box
                            sx={{
                                marginTop: 3,
                                mx: 5,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: 250
                            }}>

                            <Title>Add Demand Feed Stats</Title>
                            <Box sx={{maxWidth: 250}}>
                                <Tabs
                                    value={tab}
                                    onChange={handleTabChange}
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                    aria-label="secondary tabs example"
                                >
                                    <Tab value="automatic" label="Upload CSV"/>
                                    <Tab value="manual" label="Manual"/>
                                </Tabs>
                                <SimpleTabPanel value={tab} index={"manual"} sx={{mt: 2}}>
                                    <Box component={"form"} onSubmit={handleSubmit}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} size={"small"} sx={{flexGrow: 1, mr: 3, mt: 2}} >
                                            <Stack spacing={3} sx={{ mt: 2}}>
                                                <DesktopDatePicker
                                                    size={"small"}
                                                    label="Date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={form?.date ?? null}
                                                    name={"date"}
                                                    onChange={handleChangeDate}
                                                    renderInput={(params) => <TextField required={true}
                                                                                        size={"small"} {...params} />}
                                                />
                                            </Stack>
                                        </LocalizationProvider>
                                        <FormControl sx={{flexGrow: 1, mr: 3, mt: 2}} fullWidth={true} size={"small"}
                                                     required={true}>
                                            <InputLabel id="demand-feed-id">Demand Feed</InputLabel>
                                            <Select
                                                name={"demand_feed_id"}
                                                labelId="demand-feed-id"
                                                id="demo-simple-select"
                                                label="Demand Feed Id"
                                                onChange={handleChangeForm}
                                                size={"small"}
                                            >
                                                {demandFeeds.map((item) => <MenuItem
                                                    value={item.id}>{item.id + " - " + item.needle + " (" + item.user?.name + ")"}</MenuItem>)}


                                            </Select>
                                        </FormControl>
                                        <FormControl sx={{flexGrow: 1, mr: 3, mt: 2}} fullWidth={true} size={"small"}
                                                     required={true}>
                                            <InputLabel id="demand-feed-id">Supply Feed</InputLabel>
                                            <Select
                                                name={"supply_feed_id"}
                                                labelId="demand-feed-id"
                                                id="supply_feed_id"
                                                label="Supply Feed Id"
                                                onChange={handleChangeForm}
                                                size={"small"}
                                            >
                                                {supplyFeeds?.map((item) => <MenuItem
                                                    value={item.id}>{item.id + " - " + item.name + " (" + item.user?.name + ")"}</MenuItem>)}


                                            </Select>
                                        </FormControl>
                                        <TextField
                                            size={"small"}
                                            sx={{mt: 2}}
                                            required
                                            fullWidth={true}
                                            type={"number"}
                                            name={"revenue"}
                                            inputProps={{
                                                step: "0.01"
                                            }}
                                            errorText={"Can't be empty"}
                                            onChange={handleChangeForm}
                                            id="revenue"
                                            label="Revenue"
                                        />
                                        <TextField
                                            size={"small"}
                                            fullWidth={true}
                                            type={"number"}
                                            sx={{mt: 2}}
                                            required
                                            name={"searches"}
                                            onChange={handleChangeForm}
                                            id="searches"
                                            label="Searches"
                                        />
                                        <TextField
                                            size={"small"}
                                            fullWidth={true}
                                            sx={{mt: 2}}
                                            type={"number"}
                                            required
                                            name={"clicks"}
                                            onChange={handleChangeForm}
                                            id="clicks"
                                            label="Clicks"
                                        />


                                        <Button
                                            fullWidth
                                            variant={"outlined"}
                                            type={"submit"}
                                            sx={{mt: 3, mb: 2}}
                                        >
                                            Save
                                        </Button>
                                    </Box>

                                </SimpleTabPanel>
                                <SimpleTabPanel value={tab} index={"automatic"}>
                                    <Box component={"form"} onSubmit={handleSubmit}>

                                        <FormControl sx={{flexGrow: 1, mr: 3, mt: 2}} fullWidth={true} size={"small"}
                                                     required={true}>
                                            <InputLabel id="demand-feed-id">Demand Partner</InputLabel>
                                            <Select
                                                name={"demand_user_id"}
                                                labelId="demand-user-id"
                                                id="demand_user_id"
                                                label="Supply Feed Id"
                                                onChange={handleChangeForm}
                                                size={"small"}
                                            >
                                                {demandPartners?.map((item) => <MenuItem
                                                    value={item.id}>{item.name}</MenuItem>)}


                                            </Select>
                                        </FormControl>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            sx={{mt: 2}}
                                        >
                                            Upload CSV
                                            <input
                                                type="file"
                                                hidden
                                                required={true}
                                                onChange={handleChangeForm}
                                                name={"file"}
                                                id={"file"}
                                            />
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant={"outlined"}
                                            type={"submit"}
                                            sx={{mt: 3, mb: 2}}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </SimpleTabPanel>


                            </Box>
                        </Box>
                    </Drawer>
                </Paper>

            </Container>

        </MainLayout>

    )
}


export default DemandStats